import SHA256 from 'crypto-js/sha256';
import Hex from 'crypto-js/enc-hex';

export function hashPassword(password: string, salt: string): string {
  const hash = SHA256(password + salt);
  return Hex.stringify(hash);
}
